<template>
  <div class="form-column">
    <label class="label flex flex-align-center flex-justify-between text-smaller">
      <span class="text-uppercase">
        Line {{ index + 1 }}
      </span>
      <span class="text-normal text-muted text-nowrap text-tiny">
        {{ lineLength }}/{{ line.maxlength }}
      </span>
    </label>
    <div class="flex flex-wrap-nowrap flex-align-center">
      <input
        ref="input"
        class="input-field"
        type="text"
        :maxlength="line.maxlength"
        :value="line.value || ''"
        :readonly="disabled"
        @input="updateValue"
      >
      <svg v-if="disabled" class="block text-muted" style="margin-left: -24px;" fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
        <use href="#input-lock-icon"></use>
      </svg>
    </div>
  </div>
</template>

<script>
import { dispatchInputEvent } from '../helpers.js';

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },

    index: {
      type: Number,
      default: 0,
    },
    line: {
      required: true,
      type: Object,
    },
  },

  mounted() {
    this.$nextTick(this.triggerChange);
  },

  methods: {
    triggerChange() {
      if(this.$refs.input) {
        dispatchInputEvent(this.$refs.input, 'input');
      }
    },

    updateValue(e) {
      this.$emit('update:line', Object.assign(
        {},
        this.line,
        {value: e.target.value.replace(/[^a-zA-Z0-9\s-.&]+/i, '')}
      ));
    },
  },

  computed: {
    lineLength() {
      return Number(this.line.maxlength) - String(this.line.value || '').length;
    },
  },
}
</script>
